import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'
import { dashedBorderCssStyle } from '../../../../../views/indexing/components/ui/Draggable'

export const droppableContainerCss = css`
  border-radius: 4px;
`

export const activeBorderCss = css`
  ${droppableContainerCss};
  outline: solid 4px ${colors.blue10};
  outline-offset: 4px;
`

export const dashedDropTargetCss = css`
  ${dashedBorderCssStyle};
  border-radius: 4px;
`

export const dashedDropTargetActiveCss = css`
  ${dashedDropTargetCss};
  background-color: ${colors.blue03};
`

// Standard screen-reader-only styling: keeps the element in the accessibility tree
// (so aria-live announcements are read) without any visual footprint.
export const visuallyHiddenCss = css`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`
